<template>
  <ValidationObserver>
    <b-form-radio-group
      v-model="alternativeIdentified_sync"
      :disabled="readonly"
    >
      <b-form-radio class="ml-lg-4" :value="true">
        <div class="font-weight-normal">
          <span>
            Se identifica la alternativa de ubicación en la(s) siguiente(s)
            escuela(s) públicas:
          </span>
        </div>
      </b-form-radio>

      <div
        v-if="alternativeIdentified_sync"
        key="SchoolRecommendation_OtherRegion"
        class="pt-2"
      >
        <ValidationProvider
          v-slot="{ errors, validate }"
          :rules="{ required: validateItems }"
          :custom-messages="{ required: '.' }"
        >
          <SchoolRecommendation
            :readonly="readonly"
            :academic-year-id="academicYearId"
            :tap-request-id="tapRequestId"
            :tap-request-type-id="tapRequestTypeId"
            :region="region"
            select-region
            exclude-region
            select-municipality
            :items.sync="publicSchoolsIdentified"
            @input="validate"
          />
          <Error
            v-if="errors && errors[0]"
            variant="no-border"
            :message="errors[0]"
          />
        </ValidationProvider>
      </div>

      <div class="my-2" />

      <b-form-radio class="ml-lg-4" :value="false">
        <div class="font-weight-normal">
          <span>No se identifica la alternativa de ubicación.</span>
        </div>
      </b-form-radio>
    </b-form-radio-group>

    <ValidationProvider
      v-slot="{ errors }"
      :disabled="!validateOptions"
      :rules="{ required: true }"
:custom-messages="{
      required:
        'Favor seleccionar el proceso de búsqueda de localizaciones disponibles.',
    }"
  >
    <input
      v-model="alternativeIdentified_sync"
      type="hidden"
      required
    />
      <Error v-if="errors[0]" variant="no-border" :message="errors[0]" />
    </ValidationProvider>
  </ValidationObserver>
</template>

<script>
import Error from 'custom-error';
import { SchoolRecommendation } from '@/components/pei/ubication-tech-assistance/_components';

export default {
  name: 'AvailableLocationsOtherRegion',
  components: { Error, SchoolRecommendation },
  inject: { tapRequestId: { default: 0 } },
  props: {
    academicYearId: { type: [Number, String], required: true, default: null },
    tapRequestTypeId: { type: [Number, String], required: true, default: null },
    region: { type: Object, required: true, default: null },
    items: { type: Array, required: true, default: () => [] },
    alternativeIdentified: { type: Boolean, default: null },
    validateOptions: { type: Boolean, default: false },
    validateItems: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
  data: () => ({ publicSchoolsIdentified: [] }),
  computed: {
    alternativeIdentified_sync: {
      get() {
        return this.alternativeIdentified;
      },
      set(value) {
        this.$emit('update:alternativeIdentified', value);
      },
    },
  },
  methods: {
    syncItems() {
      const value = [...this.publicSchoolsIdentified];
      this.$emit('update:items', value);
      this.$emit('input', value.length);
    },
  },
  watch: {
    items: {
      handler(value) {
        if (!value?.length) return;
        if (!this.publicSchoolsIdentified?.length) {
          const itemsOtherRegion =
            value?.filter(({ region }) => region?.id !== this.region?.id) || [];
          if (itemsOtherRegion.length) {
            this.publicSchoolsIdentified = itemsOtherRegion;
          }
        }
      },
      deep: true,
      immediate: true,
    },
    publicSchoolsIdentified: {
      handler() {
        this.syncItems();
      },
      deep: true,
    },
  },
  created() {
    if (this.publicSchoolsIdentified.length) {
      this.alternativeIdentified_sync = true;
    }
  },
};
</script>
